/*
 * Product Image ScrollTo Interaction
 *
 **/

custom.inViewport = (() => {
  var className = '.js-in-viewport';
  var onClassName = 'in-viewport';
  var colourTarget = '.js-colour-change';
  var colourClassName = '.js-colour-section';
  var triggerHookRatioZeroClass = 'js-in-viewport--ratio-zero';

  const activeFilterClass = 'js-product-sorter-active';
  const mobileBreakpoint = 768;

  /**
   * Internal Events System
   */

  let actions = {}; // Events store

  // Subscribe to events
  function on(evt = null, callback = () => {}) {
    if (!evt || !callback || typeof callback !== 'function') return;
    actions[evt] = actions[evt] || [];
    return actions[evt].push(callback);
  }

  // Trigger events
  function trigger(evt = null, payload = {}) {
    if (!evt || !actions[evt]) return;
    return actions[evt].forEach((fn) => fn(payload));
  }

  /**
   * Helpers
   */
  function hasClass(element, className) {
    return ` ${element.className} `.indexOf(` ${className} `) > -1;
  }

  function triggerHookOffset($el = {}) {
    return $(window).height() * $el[0].triggerHookRatio;
  }

  function getScrollPosition($el = {}) {
    return $(window).scrollTop() + triggerHookOffset($el);
  }

  function inViewport($el = {}) {
    return getScrollPosition($el) > $el.offset().top;
  }

  function stickyFilterHandler($target = {}) {
    const category = $target.data('sectionCategory')
      ? $target.data('sectionCategory')
      : null;
    if (!category) return;
    const $section = $target.data('sectionCategory', category);
    const $filter = $(
      `.product-sorter--sticky[data-filter-category="${category}"]`,
    );

    if (
      $(window).scrollTop() > $section.offset().top &&
      $(window).scrollTop() < $section.offset().top + $section.outerHeight()
    ) {
      $filter.addClass(activeFilterClass);
    } else {
      $filter.removeClass(activeFilterClass);
    }
  }

  function addingClassHandler(event = null, $el = {}) {
    var $target = event ? event.data.target : $el;

    if ($target.is('.product-showcase__container'))
      stickyFilterHandler($target);

    if (inViewport($target)) {
      // If target is inside closed accordion, do nothing
      if (
        $target.closest('.js-accordion').length &&
        !$target.closest('.js-accordion').hasClass('js-accordion-open')
      )
        return;

      // add background colour
      const colourAttr = $target.attr('data-colour');
      if (typeof colourAttr !== typeof undefined && colourAttr !== false) {
        document.querySelector(colourTarget).style.backgroundColor = colourAttr;
      }
      $target.addClass(onClassName);
      return trigger('in', $target);
    }
  }

  // object fit fallback on hero & single images for IE11
  function objectFitFallback() {
    if (document.documentElement.style.objectFit === undefined) {
      //console.log('object fit fallback')

      setObjectFitFallbackFor('.hero__image');
      setObjectFitFallbackFor('.hero-small');

      // setPictureTagFallback('.' + pictureFallbackClass);

      const $singleImages = $('.single-image__image');
      $singleImages.each((index, img) => {
        setObjectFitFallbackFor($(img));
      });

      const $galleryImages = $('.gallery__slide');
      $galleryImages.each((index, img) => {
        setObjectFitFallbackFor($(img));
      });
    }
  }
  /**
   * @param {string|jQuery} className to query
   */
  function setObjectFitFallbackFor(className) {
    const $container = genJqueryNodeFor(className);
    if ($container === null) return false;

    const url = $container.find('source').data('src');
    ie11ObjectFit($container, url);
    return true;
  }

  // IE picture fallback
  function setPictureTagFallback(className) {
    const $container = genJqueryNodeFor(className);
    const $img = $container.find('img');

    if ($container === null) return false;

    const url = $container.find('source').data('src');

    // Replace fall back image (which is usually a mobile sized (portrait image) with desktop image
    $img.attr('src', url);

    // Container hidden by CSS
    $container.fadeIn(300);
  }

  /**
   * Return either a new jQuery object, a reference to the original, or null
   * @param {jQuery|string} className
   * @returns {jQuery|null}
   */
  function genJqueryNodeFor(className) {
    let $obj = null;

    // instantiate a new jquery object
    if (typeof className == 'string') {
      $obj = $(className);
    }

    //  if it's already a jqueryNode, just reference the var
    if (className.jquery) {
      $obj = className;
    }

    return $obj;
  }

  /**
   * Add css background image to jQuery Object or return false if not a jQuery Node
   * @param {jQuery} $jqueryNode
   * @param {string} url
   * @returns {boolean}
   */
  function ie11ObjectFit($jqueryNode, url) {
    // just check to make sure that we have been given a valid jquery node and url
    if ($jqueryNode && $jqueryNode.jquery && url) {
      $jqueryNode
        .css('backgroundImage', `url('${url}')`)
        .addClass('compat-object-fit');

      return true;
    }

    return false;
  }

  function init() {
    var els = [];
    $.each($(className), function (index = null, el = {}) {
      var $this = $(el);
      // Sets the trigger point to fire earlier. Users tend to scroll faster on mobile.
      if (
        $('.page-category-wall-art') &&
        window.innerWidth <= mobileBreakpoint
      ) {
        $this[0].triggerHookRatio = 0.8;
      } else {
        $this[0].triggerHookRatio = 0.65;
      }
      if ($this.hasClass(triggerHookRatioZeroClass))
        $this[0].triggerHookRatio = 0;
      addingClassHandler(null, $this);
      els.push($this);
    });

    $.each($(colourClassName), function (index = null, el = {}) {
      var $this = $(el);
      // Sets the trigger point to fire later for the bg colour change
      $this[0].triggerHookRatio = 0.4;
      addingClassHandler(null, $this);
      els.push($this);
    });

    window.addEventListener('scroll', () => {
      els.forEach((val) => {
        window.requestAnimationFrame(() => addingClassHandler(null, $(val)));
      });
    });

    // window.addEventListener('resize', () => {
    //   els.forEach((val) => {
    //     window.requestAnimationFrame(() =>  addingClassHandler(null, $(val)))
    //   })
    // })
  }

  return {
    init,
    on,
    objectFitFallback,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/in-viewport.js